module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', _vm._b({
    attrs: {
      "flat": ""
    }
  }, 'v-card', _vm.attrs, false), [_c('request-status', {
    attrs: {
      "request": _vm.request,
      "message200": false
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "overline grey lighten-4 py-0"
  }, [_c('v-btn', {
    staticClass: "ml-1 pl-0",
    attrs: {
      "loading": _vm.request.loading,
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.debounceExpensiveMethod
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("replay")])], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "mr-3",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _vm._t("toolbar-before"), _vm._v(" "), (_vm.views && _vm.views.length > 0) ? _c('v-menu', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "slot": "activator",
            "small": "",
            "outline": ""
          },
          slot: "activator"
        }, on), [_vm._v("\n          " + _vm._s(_vm.selectedView.title) + "\n          "), _c('v-icon', [_vm._v("arrow_drop_down")])], 1)]
      }
    }], null, false, 550626377)
  }, [_vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticClass: "overline py-1 my-0 grey lighten-4"
  }, [_vm._v("\n            Quick filters\n          ")]), _vm._v(" "), _c('v-list', {
    staticClass: "pa-0"
  }, [_c('v-divider'), _vm._v(" "), _vm._l((_vm.views), function(view) {
    return [_c('v-list-tile', {
      key: view.title,
      on: {
        "click": function($event) {
          _vm.selectedView = view
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(view.title)
      }
    })], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (view.title))
    })]
  })], 2)], 1)], 1) : _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._t("toolbar"), _vm._v(" "), _vm._t("pagination", function() {
    return [(_vm.totalPages && _vm.totalPages > 1) ? [(_vm.totalPages > 3) ? _c('v-btn', {
      staticClass: "hidden-xs-only",
      attrs: {
        "disabled": _vm.page <= 2 || _vm.request.loading,
        "icon": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.page = 1
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("fast_rewind")])], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
      attrs: {
        "disabled": _vm.page <= 1 || _vm.request.loading,
        "icon": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.page--
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('span', {
      staticClass: "ml-2"
    }, [_vm._v("\n            " + _vm._s(Math.max(1, (_vm.page - 1) * _vm.pageSize)) + " -\n            " + _vm._s(Math.min(_vm.numResults, _vm.page * _vm.pageSize)) + " of\n            " + _vm._s(_vm.numResults) + "\n          ")]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "disabled": _vm.page >= _vm.totalPages || _vm.request.loading,
        "icon": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.page++
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("chevron_right")])], 1), _vm._v(" "), (_vm.totalPages > 3) ? _c('v-btn', {
      staticClass: "hidden-xs-only",
      attrs: {
        "disabled": _vm.page >= _vm.totalPages || _vm.request.loading,
        "icon": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.page = _vm.totalPages
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("fast_forward")])], 1) : _vm._e()] : _vm._e()]
  }), _vm._v(" "), _c('v-spacer', {
    staticClass: "hidden-sm-and-up"
  }), _vm._v(" "), (_vm.withAdd) ? [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "mr-0",
    attrs: {
      "icon": "",
      "small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("add")])], 1)] : _vm._e(), _vm._v(" "), _vm._t("toolbar-end"), _vm._v(" "), [(_vm.cards) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('update:cards', false)
      }
    }
  }, [_c('v-icon', [_vm._v("unfold_less")])], 1) : _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('update:cards', true)
      }
    }
  }, [_c('v-icon', [_vm._v("unfold_more")])], 1)], _vm._v(" "), (_vm.multiple && _vm.withSelectAll) ? [(_vm.selectAll === false) ? _c('v-icon', {
    on: {
      "click": function($event) {
        _vm.selectAll = true
      }
    }
  }, [_vm._v("check_box_outline_blank")]) : _c('v-icon', {
    on: {
      "click": function($event) {
        _vm.selectAll = false
      }
    }
  }, [_vm._v("check_box")])] : _vm._e()], 2), _vm._v(" "), _vm._t("top"), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    staticClass: "pa-0 elevation-0 grey lighten-4",
    attrs: {
      "subheader": "",
      "three-line": "",
      "dense": _vm.dense
    }
  }, [(_vm.withSearch) ? [_c('v-text-field', {
    staticClass: "ma-0 pl-3 pt-0",
    attrs: {
      "single-line": "",
      "hide-details": "",
      "prepend-inner-icon": "search",
      "label": "search within results"
    }
  }), _vm._v(" "), _c('v-divider')] : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredAppointments), function(appt, index) {
    return _c('v-card', {
      key: ("card-" + (appt.id)),
      class: {
        'ma-2': _vm.cards
      },
      attrs: {
        "flat": !_vm.cards
      }
    }, [(_vm.withSubheaders && _vm.isNewCategory(index, _vm.filteredAppointments, 'title')) ? _c('v-subheader', {
      staticClass: "overline py-0 my-0 grey lighten-4"
    }, [_vm._v("\n          " + _vm._s(appt.title) + "\n      ")]) : _c('appointment-list-item', _vm._b({
      class: {
        "cyan lighten-4": _vm.isSelected(appt)
      },
      attrs: {
        "appointment": appt,
        "with-actions": false,
        "with-action": _vm.withAction,
        "with-pricing": _vm.withPrice,
        "with-color-coding": false,
        "with-status-chips": true
      },
      on: {
        "listitem:clicked": _vm.appointmentSelected
      }
    }, 'appointment-list-item', _vm.listAttrs, false), [(_vm.withActions) ? _c('template', {
      slot: "actions"
    }, [_vm._t("listaction", function() {
      return [_c('v-btn', {
        attrs: {
          "icon": "",
          "small": ""
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.showOptions(appt)
          }
        }
      }, [_c('v-icon', [_vm._v("more_vert")])], 1)]
    }, {
      "appointment": appt
    })], 2) : _c('template', {
      slot: "actions"
    }, [_vm._t("listaction", null, {
      "appointment": appt
    })], 2), _vm._v(" "), (_vm.multiple) ? _c('template', {
      slot: "action"
    }, [_c('v-divider', {
      staticClass: "ml-1",
      attrs: {
        "vertical": ""
      }
    }), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      }
    }, [(_vm.isSelected(appt)) ? _c('v-icon', [_vm._v("check_box")]) : _c('v-icon', [_vm._v("check_box_outline_blank")])], 1)], 1)], 1) : _vm._e()], 2), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.cards && appt.codes && appt.codes.length > 0) ? _c('v-card', {
      staticClass: "ma-0",
      attrs: {
        "flat": ""
      },
      on: {
        "click": function($event) {
          return _vm.launchDiagnosisCodes({
            value: appt,
            appointmentId: appt.id,
            editable: true,
            withTitle: true,
            withTotal: true,
            withRefresh: true,
            withInvoiceable: true
          })
        }
      }
    }, [_c('v-card-title', {
      staticClass: "pb-0 pt-1 overline"
    }, [_vm._v("Codes\n          ")]), _vm._v(" "), _c('v-card-text', _vm._l((appt.codes), function(code) {
      return _c('v-layout', {
        key: code.id
      }, [_c('v-flex', {
        attrs: {
          "xs6": ""
        }
      }, [_vm._v(_vm._s(code.icd10))]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs3": ""
        }
      }, [_vm._v(_vm._s(code.process))]), _vm._v(" "), _c('v-flex', {
        staticStyle: {
          "text-align": "right"
        },
        attrs: {
          "xs3": ""
        }
      }, [_vm._v("\n              " + _vm._s(_vm.formatCurrency(code.currency, code.price)) + "\n            ")])], 1)
    }), 1)], 1) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.filteredAppointments && _vm.filteredAppointments.length === 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s(_vm.noResultsText)
    }
  })], 1)], 1) : _vm._e()], 2), _vm._v(" "), (_vm.withActions && _vm.selectedAppointment && _vm.selectedAppointment.id) ? _c('appointment-bottom-sheet', {
    attrs: {
      "appointment": _vm.selectedAppointment
    },
    model: {
      value: (_vm.showBottomSheet),
      callback: function($$v) {
        _vm.showBottomSheet = $$v
      },
      expression: "showBottomSheet"
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f1ea8b4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lists/AppointmentList.vue
// module id = 1439
// module chunks = 9